module.exports = __webpack_public_path__ + "img/avatar_default.d64a749d.png";